<puro-modal
  class="review-terms-dialog__modal"
  [className]="'review-terms-dialog__modal'"
  [open]="open()"
  [title]="modalTitle()"
  size="large"
  [showCloseButton]="false"
  [closeOnBackdrop]="true"
  [actions]="actions()"
  (closeModal)="onDisagree()"
>
  <div class="review-terms-dialog" data-testid="review-terms-dialog">
    <puro-typography component="p" variant="body1" class="review-terms-dialog__intro">
      {{ 'createShipment.reviewAndPay.terms.modalIntro' | translate }}
    </puro-typography>

    <section
      class="review-terms-dialog__scroll"
      [attr.aria-label]="'createShipment.reviewAndPay.terms.scrollRegionAria' | translate"
    >
      <p class="review-terms-dialog__download">
        <a
          class="review-terms-dialog__download-link"
          [href]="termsPdfUrl()"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="review-terms-pdf-link"
        >
          {{ 'createShipment.reviewAndPay.terms.downloadPdf' | translate }}
        </a>
      </p>
      @for (section of sections(); track section.title) {
        <section class="review-terms-dialog__section">
          <h3 class="review-terms-dialog__section-title">{{ section.title }}</h3>
          <div class="review-terms-dialog__section-body" [innerHTML]="section.body"></div>
        </section>
      }
      @if (loadFailed()) {
        <p
          class="review-terms-dialog__load-error"
          role="alert"
          data-testid="review-terms-load-error"
        >
          {{ 'createShipment.reviewAndPay.terms.loadFailed' | translate }}
        </p>
      }
    </section>
  </div>
</puro-modal>
